var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"variant":"primary","title":"Realiza o download do modelo (template)"},on:{"click":function($event){$event.stopPropagation();return _vm.download()}}},[_c('span',[_c('i',{staticClass:"fa fa-download"}),_vm._v(" Download Modelo")])])
}
var staticRenderFns = []

export { render, staticRenderFns }